(function() {
    "use strict";

    var directive = function factory() {
        return {
            templateUrl: 'app/modules/web/directives/masthead-directive.html',
            replace: true,
            transclude: false,
            restrict: 'E',
            controller: 'MastheadController'
        };
    };

    webModule.directive('tlcMasthead', directive);

}());
